import * as React from "react";
import { Redirect } from "react-router-dom";

import { LOGS_ROUTE } from "components/router/Routes";

export default function AuditLogsParentView() {
    return <Redirect to={LOGS_ROUTE.path} />;
}
